import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=44b80a59&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=44b80a59&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b80a59')) {
      api.createRecord('44b80a59', component.options)
    } else {
      api.reload('44b80a59', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=44b80a59&", function () {
      api.rerender('44b80a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/user/components/detail.vue"
export default component.exports